import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

axios.defaults.timeout = 30000

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/aira/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const mainAiraApi = {
  getSeminar: (request) => {
    const { config } = request
    return instance().get('/manage-seminar', {
      params: config
    })
  },
  getSeminarById: (request) => {
    const { config, id } = request
    return instance().get(`/manage-seminar/${id}`, config)
  },
  postImportSeminar: (request) => {
    const { data, pageId } = request
    return instance().post(`/manage-seminar`, data, {
      params: {
        page_id: pageId
      }
    })
  },
  putUpdateSeminar: (request) => {
    const { data, id, pageId } = request
    return instance().put(`/manage-seminar/${id}`, data, {
      params: {
        page_id: pageId
      }
    })
  },
  deleteSeminar: (request) => {
    const { pageId, id } = request
    return instance().delete(`/manage-seminar/${id}`, {
      params: {
        page_id: pageId
      }
    })
  },
  getBookingSeminar: (request) => {
    const { config } = request
    return instance().get('/booking-seminar', {
      params: config
    })
  },
  postSaveBroadcast: (request) => {
    const { data, pageId } = request
    return instance().post(`/broadcast`, data, {
      params: {
        page_id: pageId
      }
    })
  },
  getBroadcast: (request) => {
    const { config } = request
    return instance().get('/broadcast', {
      params: config
    })
  },
  deleteBroadcast: (request) => {
    const { pageId, id } = request
    return instance().delete(`/broadcast/${id}`, {
      params: {
        page_id: pageId
      }
    })
  },
  putUpdateBroadcast: (request) => {
    const { data, pageId } = request
    return instance().put(`/broadcast`, data, {
      params: {
        page_id: pageId
      }
    })
  },
  getMembers: (request) => {
    const { params } = request
    // page_id={{AIRA_PAGE_ID}}
    // aira_id=
    // social_name=
    // phone_number=
    // email=
    // status=
    // channel=
    // dateto
    // datefrom
    // sort_by=aira_id
    // sort_type=
    // limit=10
    // offset=0
    return instance().get('/member', {
      params
    })
  },
  getBroadcastLog: (request) => {
    const { params, id } = request
    // page_id
    // limit
    // offset
    // status
    return instance().get(`/broadcast-log/${id}`, {
      params
    })
  }
}

export default mainAiraApi



// WEBPACK FOOTER //
// ./src/api/aira.js